module.exports = __webpack_public_path__ + "assets/images/help-center@2x-381d99dab971bc9e145a1bfe15f5ebcd.jpg";